"use client";

import { ProductDetails } from "@/lib/centra/formatters";
import { ProductJsonLd } from "next-seo";
import { useSearchParams } from "next/navigation";
import { buildProductJsonLd } from "./product";

const ProductMeta = ({ productData }: { productData: ProductDetails }) => {
  const searchParams = useSearchParams();
  const currency = searchParams.get("currency");
  return (
    <ProductJsonLd
      {...buildProductJsonLd(productData, currency as string)}
      useAppDir={true}
    />
  );
};
export default ProductMeta;
